import React from 'react';
import { Box, Typography, Paper, Skeleton } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid
} from 'recharts';
import { formatMoney } from '../../../utils/currency';

const AverageCostByCategoryChart = ({ data = [], loading }) => {
  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant="subtitle1" gutterBottom>
        Costo promedio por categoría
      </Typography>
      <Box sx={{ width: '100%', height: 300 }}>
        {loading ? (
          <Skeleton variant="rectangular" width="100%" height={300} />
        ) : data.length > 0 ? (
          <ResponsiveContainer>
            <BarChart data={data} margin={{ top: 10, right: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="category" />
              <YAxis />
              <Tooltip formatter={(value) => `${formatMoney(value)}`} />
              <Bar dataKey="cost" fill="#42a5f5" name="Costo promedio" />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body2" color="textSecondary">
              No hay datos disponibles.
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default AverageCostByCategoryChart;
